export const BANGLADESH_COUNTRY_CODE = '+880';

function digitsOnly(value: unknown): string {
  return `${value ?? ''}`.replace(/\D+/g, '');
}

export function extractBangladeshMobileLocalPart(value: unknown): string {
  let digits = digitsOnly(value);
  if (!digits) {
    return '';
  }
  if (digits.startsWith('880')) {
    digits = digits.slice(3);
  }
  return digits.replace(/^0+/, '');
}

export function normalizeBangladeshMobileLocalInput(value: unknown): string {
  return extractBangladeshMobileLocalPart(value);
}

export function combineBangladeshMobileNumber(value: unknown): string | null {
  const localPart = normalizeBangladeshMobileLocalInput(value);
  if (!localPart) {
    return null;
  }
  return `${BANGLADESH_COUNTRY_CODE}${localPart}`;
}

export function isValidBangladeshMobileLocalPart(value: unknown, required = false): boolean {
  const localPart = normalizeBangladeshMobileLocalInput(value);
  if (!localPart) {
    return !required;
  }
  return /^1\d{9}$/.test(localPart);
}
